import type { AnalyticsState } from './types';

export const createStore = (initialState: AnalyticsState = {}) => {
  let currentState = initialState;

  const getState = () => currentState;

  const update = (newState: AnalyticsState) => {
    currentState = newState;
  };

  return {
    getState,
    update,
  };
};
